<app-error-message-table-search
  (searchTriggered)="onSearchTriggered($event)"
  [recyclingModeEnabled]="recyclingModeEnabled"
></app-error-message-table-search>
<div
  #scrollContainer
  class="relative overflow-x-auto shadow-md sm:rounded-lg max-h-screen-200 min-h-screen-200 overflow-y-auto mt-2"
>
  <table class="w-full text-sm text-left rtl:text-right text-gray-500">
    <thead class="text-xs uppercase bg-amazone-orange text-gray-100 sticky top-0">
      <tr>
        <th scope="col" class="px-6 py-3">
          <app-header-sorter
            [headerTitle]="'Message Code'"
            [field]="getPropertyName('code')"
            [arrow]="sortingConfiguration.getArrowDirection(getPropertyName('code'))"
            (clicked)="sortBy($event)"
          ></app-header-sorter>
        </th>
        <th scope="col" class="px-6 py-3">
          <app-header-sorter
            [headerTitle]="'Header on terminal'"
            [field]="getPropertyName('headerOnTerminal')"
            [arrow]="sortingConfiguration.getArrowDirection(getPropertyName('headerOnTerminal'))"
            (clicked)="sortBy($event)"
          ></app-header-sorter>
        </th>
        <th scope="col" class="px-6 py-3">
          <app-header-sorter
            [headerTitle]="'Details on Terminal'"
            [field]="getPropertyName('detailsOnTerminal')"
            [arrow]="sortingConfiguration.getArrowDirection(getPropertyName('detailsOnTerminal'))"
            (clicked)="sortBy($event)"
          ></app-header-sorter>
        </th>
        <th scope="col" class="px-6 py-3">
          <app-header-sorter
            [headerTitle]="'Category'"
            [field]="getPropertyName('category')"
            [arrow]="sortingConfiguration.getArrowDirection(getPropertyName('category'))"
            (clicked)="sortBy($event)"
          ></app-header-sorter>
        </th>
        @if (!recyclingModeEnabled) {
          <th scope="col" class="px-6 py-3">DTC(s) Assigned</th>
        }
        <th scope="col" class="px-6 py-3">
          <app-header-sorter
            [headerTitle]="'Tr. UT'"
            [field]="getPropertyName('translationStateTerminal')"
            [arrow]="sortingConfiguration.getArrowDirection(getPropertyName('translationStateTerminal'))"
            (clicked)="sortBy($event)"
          ></app-header-sorter>
        </th>
        <!-- HINT: Currently modified by might not be the user who deactivated the item -->
        <!-- @if (recyclingModeEnabled) {
          <th scope="col" class="px-6 py-3">
            <app-header-sorter
              [headerTitle]="'Deactivated By'"
              [field]="getPropertyName('modifiedBy')"
              [arrow]="sortingConfiguration.getArrowDirection(getPropertyName('modifiedBy'))"
              (clicked)="sortBy($event)"
            ></app-header-sorter>
          </th>
        } -->
        <th scope="col" class="px-6 py-3">
          <app-header-sorter
            [headerTitle]="'Last Update'"
            [field]="getPropertyName('modifiedOn')"
            [arrow]="sortingConfiguration.getArrowDirection(getPropertyName('modifiedOn'))"
            (clicked)="sortBy($event)"
          ></app-header-sorter>
        </th>
        <th scope="col" class="px-6 py-3">Actions</th>
      </tr>
    </thead>
    <tbody>
      @if (errorMessages?.length === 0) {
        <tr>
          <td class="px-6 py-4 text-center font-medium text-amazone-orange whitespace-nowrap" colspan="5">
            No error messages found
          </td>
        </tr>
      }
      @for (msg of errorMessages; track $index) {
        <tr
          (click)="onErrorMessageClicked($safeNavigationMigration(msg?.id))"
          [ngClass]="
            isSelected($safeNavigationMigration(msg?.id))
              ? 'bg-orange-100 sticky top-15 bottom-0 text-amazone-orange translated-x-1 border-l-4 border-amazone-orange'
              : 'odd:bg-white even:bg-gray-50 hover:bg-gray-100 hover:text-amazone-orange border-b border-gray-200 '
          "
          class="transition-all duration-150"
        >
          <th scope="row" class="px-6 py-4 w-40 font-semibold whitespace-nowrap cursor-pointer">
            {{ msg?.code ?? 'N/A' }}
          </th>
          <td class="px-6 py-4 cursor-pointer">
            {{ msg?.headerOnTerminal ?? 'N/A' }}
          </td>
          <td class="px-6 py-4 cursor-pointer whitespace-nowrap">
            {{ commonUtils.truncateString(msg?.detailsOnTerminal ?? 'N/A', 50) }}
          </td>
          <td class="px-6 py-4 cursor-pointer">
            {{ msg?.category ?? 'N/A' }}
          </td>
          @if (!recyclingModeEnabled) {
            <td class="px-6 py-4 cursor-pointer">
              @if (msg?.dtcIds?.length ?? 0 > 0) {
                <app-check-icon></app-check-icon>
              } @else {
                <span class="ms-1">-</span>
              }
            </td>
          }
          <td class="px-6 py-4 cursor-pointer">
            <span
              class="ml-2.5 inline-block size-2.5 shrink-0 rounded-full"
              [ngClass]="commonUtils.translationStateToColor($safeNavigationMigration(msg?.translationStateTerminal))"
              title="{{
                commonUtils.friendlyTranslationState($safeNavigationMigration(msg?.translationStateTerminal))
              }}"
            >
            </span>
          </td>
          <td
            class="px-6 py-4 cursor-pointer whitespace-nowrap"
            [ngClass]="{ 'font-semibold': commonUtils.isToday($safeNavigationMigration(msg?.modifiedOn)) }"
          >
            {{ $safeNavigationMigration(msg?.modifiedOn) | date: 'yyyy.MM.dd HH:mm' }}
          </td>
          <td class="px-6 py-4">
            <div class="w-5 grid grid-cols-3 gap-10">
              @if (recyclingModeEnabled) {
                <button
                  [appEnabledByPolicy]="policy.canDeleteHard"
                  type="button"
                  (click)="
                    showDecisionModal(
                      $safeNavigationMigration(msg?.id),
                      $safeNavigationMigration(msg?.headerOnTerminal)
                    );
                    deleteDecisionModal.openModal();
                    $event.stopPropagation()
                  "
                  class="font-medium text-red-400 disabled:text-gray-400 hover:text-red-600 cursor-pointer hover:scale-110 disabled:cursor-not-allowed"
                  [disabled]="hardDeleteDisabled"
                  appAgentAction
                  [agent]="'error-message-hard-delete-' + msg.id"
                  businessObject="errorMessage"
                  [businessId]="msg.id"
                  action="delete"
                >
                  <app-delete-icon></app-delete-icon>
                </button>
                <button
                  [appEnabledByPolicy]="policy.canRestore"
                  (click)="restoreErrorMessage(msg); $event.stopPropagation()"
                  type="button"
                  class="font-medium text-blue-400 disabled:text-gray-400 hover:text-blue-600 cursor-pointer hover:scale-110 disabled:cursor-not-allowed"
                  [disabled]="restoreDisabled"
                  appAgentAction
                  [agent]="'error-message-restore-' + msg.id"
                  businessObject="errorMessage"
                  [businessId]="msg.id"
                  action="restore"
                >
                  <app-restore-icon></app-restore-icon>
                </button>
              } @else {
                <button
                  type="button"
                  [appEnabledByPolicy]="policy.canDeleteSoft"
                  (click)="
                    showDecisionModal(
                      $safeNavigationMigration(msg?.id),
                      $safeNavigationMigration(msg?.headerOnTerminal)
                    );
                    softDeleteDecisionModal.openModal();
                    $event.stopPropagation()
                  "
                  class="font-medium text-red-400 disabled:text-gray-400 hover:text-red-600 cursor-pointer hover:scale-110 disabled:cursor-not-allowed"
                  [disabled]="softDeleteDisabled"
                  appAgentAction
                  [agent]="'error-message-deactivate-' + msg.id"
                  businessObject="errorMessage"
                  [businessId]="msg.id"
                  action="deactivate"
                >
                  <app-delete-icon></app-delete-icon>
                </button>
              }
              @if (msg?.internalNotes) {
                <app-note-icon class="text-orange-300"></app-note-icon>
              }
            </div>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
<app-decision-modal
  #softDeleteDecisionModal
  (decision)="onSoftDeleteDecision($event)"
  [entityId]="$safeNavigationMigration(errorMessageToRemove?.id)"
  [entityName]="$safeNavigationMigration(errorMessageToRemove?.headerOnTerminal)"
  [businessObject]="'errorMessage'"
  [header]="'Deactivation of'"
  [details]="[
    'This Error Message will not be permanently deleted, but only deactivated. Additionally, all links to the DTCs will be removed. Do you want to proceed?',
  ]"
></app-decision-modal>
<app-decision-modal
  #deleteDecisionModal
  (decision)="onHardDeleteDecision($event)"
  [entityId]="$safeNavigationMigration(errorMessageToRemove?.id)"
  [entityName]="$safeNavigationMigration(errorMessageToRemove?.headerOnTerminal)"
  [businessObject]="'errorMessage'"
  [header]="'Deletion of'"
  [details]="['The Error Message will be permanently deleted. Do you want to proceed?']"
></app-decision-modal>
